import { useEffect } from "react";
import PageHero from "@/components/PageHero";
import SEO, { buildBreadcrumbJsonLd } from "@/components/SEO";
import { seoConfig } from "@/data/seoConfig";

const Careers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO {...seoConfig.careers} jsonLd={[buildBreadcrumbJsonLd(seoConfig.careers.crumbs)]} />
      <PageHero title="Careers" crumbs={[{ label: "Home", href: "/" }, { label: "Careers" }]} lightfall />

      <section data-testid="careers-jobs-section" className="pt-24 lg:pt-12 pb-24 lg:pb-16 bg-white">
        <div className="max-w-2xl mx-auto px-6 text-center mb-14">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-miti-blue">Join Our Team</span>
          <h2 className="mt-4 font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900">
            Current Openings
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-500">
            Explore opportunities to grow your career with us.
          </p>
        </div>
        <div className="max-w-[1800px] mx-auto px-4 sm:px-6">
          <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-2xl shadow-slate-900/10">
            <iframe
              data-testid="careers-jobs-iframe"
              src="https://app.quikhyr.ai/embedded-jobs/NzI="
              title="Open Positions"
              className="w-full min-h-[1400px] border-0"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Careers;
